var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCheckAll = function SvgCheckAll(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6 17.3-4.25-4.25a.92.92 0 0 1-.288-.7q.013-.4.313-.7.3-.275.7-.287.4-.013.7.287l3.55 3.55 1.4 1.4-.725.7q-.3.276-.7.287A.92.92 0 0 1 6 17.3m5.65 0L7.4 13.05a.93.93 0 0 1-.275-.687q0-.413.275-.713.3-.3.712-.3.413 0 .713.3l3.525 3.525 8.5-8.5q.3-.3.7-.288t.7.313q.275.3.288.7a.92.92 0 0 1-.288.7l-9.2 9.2q-.3.3-.7.3a.96.96 0 0 1-.7-.3m.7-4.95-1.425-1.4 4.25-4.25a.93.93 0 0 1 .688-.275q.412 0 .712.275.3.3.3.712 0 .413-.3.713z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCheckAll);
export { ForwardRef as ReactComponent };